import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import '@loyal_template/loading.css'

const textLoading1 = () => {
  return 'Você quer trocar seus pontos?'
}

const textLoading2 = () => {
  return 'Se precisar pode completar com dinheiro.'
}

const enjoy = () => {
  return 'Aproveite ;)'
}

class RedirectPoints extends Component {
  render () {
    return (
      <div className='row loading-screen screen-default'>
        <div className='col-12 bg-brand-4 progress-loader p-0'>
          <div className='progress-bar' />
        </div>
        <div className='col-12 bg-brand-2 txt-loading py-5 d-flex align-items-center justify-content-center'>
          <div>
            <div id='logo'>
              <div className='mr-auto ml-auto txt-center logo-header'>
                <Link to='/' tabIndex='0' title={textLoading1() + ' ' + textLoading2()}>
                  <span className='d-none'>{process.env.REACT_APP_TITLE || 'Web Prêmios'}</span>
                </Link>
              </div>
            </div>
            <p className='cash color-ui-white txt-normal mx-auto mt-2'>{textLoading1()}</p>
            <p className='cash color-ui-white txt-normal mx-auto'>{textLoading2()}</p>
            <p className='color-brand-6 txt-normal mx-auto mb-2'>{enjoy()}</p>
            <div className='btn-loading loader-screen mx-auto' />
          </div>
        </div>
      </div>
    )
  }
}

export default RedirectPoints



// WEBPACK FOOTER //
// ./src/App/MainMenu/OnlyCash/RedirectPoints.js